import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '被依赖',
    type: 'DBINS_DEPENDENCE_BY',
}
